export const USER_MENTION_PREFIX = '@';
